import { useMemo } from 'react';

import { Platform } from 'react-native';

import { StreamTypes } from 'store/player/actions.types.ts';
import { RBChannel } from 'store/railsBuilder/reducer.types';

import { VideoItem } from 'services/data-manager/types';

import isPlaybackBlackedOut from 'utils/isPlaybackBlackedOut.ts';

type Params = {
    videoItem: VideoItem | undefined;
    channel: RBChannel | undefined;
    playbackType: StreamTypes | undefined;
};

function usePlayerBlackout({ videoItem, channel, playbackType }: Params) {
    const isPlayerBlackout = useMemo(() => {
        if (playbackType === StreamTypes.live) {
            const eventGlobalFlag = videoItem?.clientGlobalBlackoutControl;
            const eventPlatformFlag = Platform.select({
                web: videoItem?.clientWebBlackoutControl,
                default: videoItem?.clientMobileBlackoutControl,
            });
            const channelGlobalFlag =
                channel?.editorial?.clientGlobalBlackoutControl;
            const channelPlatformFlag = Platform.select({
                web: channel?.editorial?.clientWebBlackoutControl,
                default: channel?.editorial?.clientMobileBlackoutControl,
            });

            return isPlaybackBlackedOut({
                eventGlobalFlag,
                eventPlatformFlag,
                channelGlobalFlag,
                channelPlatformFlag,
            });
        }

        return false;
    }, [videoItem, channel, playbackType]);

    return {
        isPlayerBlackout,
    };
}

export default usePlayerBlackout;
